import { ref } from 'vue'
import axios from '../plugins/axios'
import moment from 'moment'

export function usePacket(route, apiPath = 'packet') {
  const packet = ref({
    id: '',
    norad: '',
    station: '',
    satellite: '',
    time: '',
    data: '',
    hex: '',
    frame_type: ''
  })

  async function getPacket() {
    const { data } = await axios.get(`/v1/${apiPath}/${route.params.id}`)
    packet.value = data
  }

  function formatDate(time) {
    return moment(time).format('LLL')
  }

  function base64ToArrayBuffer(base64) {
    const binary_string = atob(base64)
    const len = binary_string.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i)
    }
    return bytes.buffer
  }

  return {
    packet,
    getPacket,
    formatDate,
    base64ToArrayBuffer
  }
}